var estateStoreMutations;
(function (estateStoreMutations) {
    estateStoreMutations["SET_METHOD"] = "SET_METHOD";
    estateStoreMutations["SET_ESTATE_LIST"] = "SET_ESTATE_LIST";
    estateStoreMutations["SET_PRELOAD_CREATE"] = "SET_PRELOAD_CREATE";
    estateStoreMutations["SET_SINGLE_ESTATE_LIST"] = "SET_SINGLE_ESTATE_LIST";
    estateStoreMutations["SET_ESTATE_ATTACHMENT_PAYLOAD"] = "SET_ESTATE_ATTACHMENT_PAYLOAD";
    estateStoreMutations["RESET_STATE"] = "RESET_STATE";
    estateStoreMutations["CHANGE_STATE"] = "CHANGE_STATE";
    estateStoreMutations["SET_USER"] = "SET_USER";
    estateStoreMutations["SET_FORM_PROPS"] = "SET_FORM_PROPS";
    estateStoreMutations["SET_PROP_IDS"] = "SET_PROP_IDS";
    estateStoreMutations["UPDATE_STEP"] = "UPDATE_STEP";
    estateStoreMutations["SET_UPLOADED_IMAGE"] = "SET_UPLOADED_IMAGE";
    estateStoreMutations["REMOVE_ATTACHED_FILE"] = "REMOVE_ATTACHED_FILE";
    estateStoreMutations["SET_ADVERTISED_RENT"] = "SET_ADVERTISED_RENT";
    estateStoreMutations["UPDATE_ATTCHED_FILE"] = "UPDATE_ATTCHED_FILE";
    estateStoreMutations["SET_STATE"] = "SET_STATE";
    estateStoreMutations["SET_PREVIEWMODE"] = "SET_PREVIEWMODE";
})(estateStoreMutations || (estateStoreMutations = {}));
export default estateStoreMutations;
